/**
 * Contactos escritos a mano, para las pantallas que no pueden preguntarle al servidor.
 *
 * ⚠️ **El widget flotante ya NO lee de aquí.** Sus números viven en el directorio que ops
 * administra en booking-internal y llegan por `/api/support-directory`; el de
 * Reservaciones está sembrado ahí, así que el socio ve el mismo de siempre. Corregir un
 * número dejó de exigir un despliegue del front — para el widget.
 *
 * Lo que queda es para el **welcome público** (`FAQSection`, `NavigationBar`) y para
 * `AiTravelReportPage`. Esas pantallas siguen con el número a mano por una razón concreta
 * y no por olvido: `/api/support-directory` está detrás de `auth:sanctum`, y `/welcome` es
 * ruta pública. Un prospecto sin sesión no puede leer el directorio.
 *
 * El día que negocio quiera un contacto administrable también en el welcome, hace falta un
 * endpoint público recortado. Es historia aparte; hasta entonces, esto es la única forma
 * de que el prospecto vea un número.
 */

export const CONTACTS = {
	reservations: {
		name: 'Reservaciones',
		number: '528181618606',
		description:
			'¿Ya eres cliente y desea aclarar una duda sobre algún servicio? Contacte a Reservaciones',
		url: 'https://wa.me/528181618606',
	},

	sales: {
		name: 'Ventas',
		number: '528120299559',
		description:
			'¿Buscas más información sobre nuestros servicios? Contacta a Ventas',
		url: 'https://wa.me/528120299559',
	},

	productManager: {
		name: 'Product Manager',
		number: '528110294945',
		description:
			'¿Eres un proveedor que desea informes para aliarse con Enlaceforte? Contacta a Product Manager',
		url: 'https://wa.me/528110294945',
	},

	email: 'info@enlacebooking.com',
	emailPrivacy: 'privacidad@enlaceforte.com',
	emailReservations: 'reservaciones@enlacebooking.com',
} as const

export type ContactKey = keyof typeof CONTACTS
